// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3FJqB","header":"MergedInvoice_header__12GP1"};